<script>
import { mapState } from "vuex"

import Back from "@/components/back.vue"
import DataFlowDiagram from "@/components/groups/diagram/DataFlowDiagram.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  name: "NewDataFlow",
  components: { DataFlowDiagram, Back },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data: () => ({
    isSaveModalOpened: false,
    selectedTechnology: ""
  })
}
</script>

<template>
  <div v-if="projectStore.selectedProject">
    <div class="layout__content__header layout__content__header--white">
      <Back :route="`/groups/${$route.params.customerId}/${$route.params.projectId}`" :text="'zpet'" />
      <div class="row">
        <div class="col-md-4 offset-md-4">
          <h1 class="text-center mb-2 mb-md-3">
            {{ $t("ADD_DATA_FLOW") }}
          </h1>
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <button
            :disabled="!selectedTechnology"
            class="btn btn-primary primary-shadow d-flex align-items-center justify-content-center mr-2"
            @click="isSaveModalOpened = true"
          >
            <span class="atom-icon">
              <img alt="" src="@/assets/icons/actions/ico-btn-ulozit.svg" />
            </span>
            {{ $t("FINISH") }}
          </button>
          <button class="btn btn-outline-primary mr-3 d-inline-flex px-2" @click="$refs.diagram.reset()">
            <span class="atom-icon d-inline-flex mx-0" style="margin-top: -5px">
              <img alt="" src="@/assets/icons/actions/ico-ico-delete-l.svg" />
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="layout__content__content overflow-auto pb-0">
      <DataFlowDiagram
        ref="diagram"
        :is-save-modal-opened="isSaveModalOpened"
        @close-save="isSaveModalOpened = false"
        @technology-changed="selectedTechnology = $event"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped />
